'use client';
/** @jsxImportSource @emotion/react */

import type { CircularProgressProps } from '@mui/material/CircularProgress';

import MuiCircularProgress from '@mui/material/CircularProgress';

/**
 * @deprecated Please use `Spinner` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-spinner-migration--spinner-migration-guide Migration guide}
 */
export type { CircularProgressProps };
/**
 * @deprecated Please use `Spinner` from `@zeus/core/next` instead.
 * @see {@link https://zeus.serko.travel/?path=/docs/zeus-core-next-components-spinner-migration--spinner-migration-guide Migration guide}
 */
export const CircularProgress = MuiCircularProgress;
